import AnchorLink from '@src/components/atoms/links/anchor-link';
import GovActionMetadataCopiableDescriptionField from '@src/components/atoms/metadataCopiableDescription';
import type { ProposalType } from '@src/models/types';
import { handleNavigationUrl } from '@src/utils/metadataUtils';
import React from 'react';

export default function ConstitutionProposalDetails({
  proposal,
}: {
  proposal: ProposalType;
}) {
  return (
    <React.Fragment>
      {proposal.details?.anchor?.url && (
        <div className="flex flex-col gap-1">
          <p className="body16 font-semibold dark:text-white">
            New constitution link
          </p>
          <AnchorLink
            href={handleNavigationUrl(proposal.details.anchor.url)}
            className="body14 max-w-[210px] text-gray-400 hover:text-primary-500 sm:max-w-[300px] xl:max-w-[500px]"
            target="_blank"
          >
            {proposal.details.anchor.url}
          </AnchorLink>
        </div>
      )}
      {proposal.details?.anchor?.dataHash && (
        <GovActionMetadataCopiableDescriptionField
          label="New constitution hash:"
          value={proposal.details?.anchor?.dataHash}
        />
      )}
      {proposal.details?.script && (
        <GovActionMetadataCopiableDescriptionField
          label="New constitution script hash"
          value={proposal.details?.script}
        />
      )}
    </React.Fragment>
  );
}
